export default __webpack_public_path__ + "static/media/518.3621006e.png";